module.exports = __webpack_public_path__ + "img/fig07.c4735a23.jpg";